/// <amd-module name="Reporting/BoardsCommon/ReportLoading" />
import * as React from "react";
import { Spinner } from "VSSUI/Spinner";

/** Encapsulates loading experience for Analytics Reports. */
export class ReportLoading extends React.Component {
    public render(): JSX.Element {
        return <Spinner />;
    }
}
